export const ZadostiSopWebSelectedLeftMenuType = {
    ROZPRACOVANE: 'ROZPRACOVANE',
    VE_ZPRACOVANI: 'VE_ZPRACOVANI',
} as const;

export type ZadostiSopWebSelectedLeftMenuType = (typeof ZadostiSopWebSelectedLeftMenuType)[keyof typeof ZadostiSopWebSelectedLeftMenuType];
